import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PetDetail, PetType, RegistrationPetDetail, RegistrationPetDialogResult } from './../../../interfaces/pet';
import { getFormData, logFormData } from '../../../utils/form-util';

import { BranchDetail } from './../../../interfaces/branch';
import { Component } from '@angular/core';
import { DataMappingService } from './../../../services/data-mapping.service';
import { JsonDataService } from './../../../services/json-data.service';
import { LanguageService } from './../../../services/language.service';
import { ModalService } from '@coreui/angular';
import { PetService } from './../../../services/pet.service';
import { RegistrationPetDetailDialogComponent } from './../../../dialogs/registration-pet-detail-dialog/registration-pet-detail-dialog.component';
import { SuccessDialogComponent } from './../../../dialogs/success-dialog/success-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { environment } from './../../../../environments/environment.prod'

@Component({
  selector: 'app-pet-register',
  templateUrl: './pet-register.component.html',
  styleUrls: ['./pet-register.component.scss']
})
export class PetRegisterComponent {

  petRegisterForm: FormGroup;
  petRegisterData = new FormData();
  nationalityList: string[] = [];
  selectedNationality = '';
  isRegisteringPet = false;
  selectedVaccinationProofFile: File | null = null;
  successModal: any;
  position = 'top-end';
  visible = false;
  percentage = 0;
  supportedLanguages = ['en', 'kh']; // Add your supported languages
  currentLanguage: string;
  referralList: string[] = [];
  selectedReferral = '';
  selectedPetSex = '';
  selectedPetIsFriendly = '';
  selectedPetIsSensitiveBodyOrPhysicalRestriction = '';
  selectedPetIsTicksFleesTreated = '';
  selectedPetIsRecentlyDeWormed = '';
  selectedPetIsSpecialDietaryRequirements = '';
  selectedPetIsIllLast30Days = '';
  selectedPetIsMedicalConditionsInjuriesIllnesses = '';
  selectedPetIsAllergiesFoodSensitivities = '';
  selectedPetIsSkinProblems = '';
  isBranchesLoaded = false;
  branchesList = [] as BranchDetail[];
  selectedBranch = {} as BranchDetail;
  petTypes = [] as PetType[];
  selectedPetType = {} as PetType;

  petDetailModal: any;
  petsList = [] as RegistrationPetDetail[];
  selectedPet = {} as RegistrationPetDetail;
  vaccinatedProofFilesList = [] as File[];

  // Pickup
  isPickUpServiceNeededAnswer = '';
  selectedPickUpTime: Date = new Date();

  constructor(private formBuilder: FormBuilder,
    private jsonDataService: JsonDataService,
    private petService: PetService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private languageService: LanguageService,
    private dataMappingService: DataMappingService) {
    this.nationalityList = this.jsonDataService.jsonNationality;
    this.currentLanguage = this.languageService.getSelectedLanguage();
    console.log(`supportedLanguages: ${this.supportedLanguages}`);
    console.log(`currentLanguage: ${this.currentLanguage}`);
    this.getBranches();
    this.getPetTypes();

    this.petRegisterForm = this.formBuilder.group({
      branchName: '',
      ownerFirstName: '',
      ownerLastName: '',
      ownerPhone: '',
      ownerEmail: '',
      ownerAddress: '',
      ownerEmergencyContact: '',
      ownerNationality: '',
      ownerVetDetails: '',
      // howDidYouHear: '',
      howDidYouHearAboutGoodDog: '',
      howDidYouHearAboutGoodDogOther: '',
      isPickUpServiceNeeded: '',
      pickUpFirstName: '',
      pickUpLastName: '',
      pickUpPhone: '',
      pickUpAddress: '',
      pickUpDate: '',
      pickUpTime: '',
      petType: '',
      petName: '',
      petWeight: '',
      petSex: '',
      petAge: [''],
      petBreed: [''],
      petIsSpayedNeutered: [''],
      petLastHeatDate: [''],
      petIsFriendly: [''],
      petIsSensitiveBodyOrPhysicalRestriction: [''],
      petSensitiveBodyOrPhysicalRestrictionDetails: [''],
      petIsFullyVaccinated: [''],
      petVaccinatedProof: [null],
      petIsRabiesVaccinated: [''],
      petIsSkinProblems: [''],
      petIsTicksFleesTreated: [''],
      petTicksFleesTreatedDate: [''],
      petTicksFleesTreatedHowTo: [''],
      petIsRecentlyDeWormed: [''],
      petRecentlyDeWormedDate: [''],
      petIsSpecialDietaryRequirements: [''],
      petSpecialDietaryRequirementsDescription: [''],
      petIsIllLast30Days: [''],
      petIsIllLast30DaysExplanation: [''],
      petIsDisplayingSymptomsCoughingSneezingUpsetStomach: [''],
      petIsMedicalConditionsInjuriesIllnesses: [''],
      petMedicalConditionsInjuriesIllnessesDetails: [''],
      petIsAllergiesFoodSensitivities: [''],
      petAllergiesFoodSensitivitiesDetails: [''],
      isAllowedPhotoVideoUsage: [''],
      isDisclaimerAgreed: '',
      disclaimerAgreement: [false, Validators.requiredTrue],
      pets: new FormGroup({
        pet_name: new FormControl(),
      })
    });

    this.setFormFieldsSelectedValue();
  }

  buildForm() {
    this.petRegisterForm = this.formBuilder.group({
      ownerFirstName: '',
      ownerLastName: '',
      ownerPhone: '',
      ownerEmail: '',
      ownerAddress: '',
      ownerEmergencyContact: '',
      ownerNationality: '',
      ownerVetDetails: '',
      howDidYouHearAboutGoodDog: '',
      howDidYouHearAboutGoodDogOther: '',
      isPickUpServiceNeeded: '',
      pickUpFirstName: '',
      pickUpLastName: '',
      pickUpPhone: '',
      pickUpAddress: '',
      pickUpDate: '',
      pickUpTime: '',
      petType: '',
      petName: '',
      petWeight: '',
      petSex: '',
      petAge: [''],
      petBreed: [''],
      petIsSpayedNeutered: [''],
      petLastHeatDate: [''],
      petIsFriendly: [''],
      petIsSensitiveBodyOrPhysicalRestriction: [''],
      petSensitiveBodyOrPhysicalRestrictionDetails: [''],
      petIsFullyVaccinated: [''],
      petVaccinatedProof: [null],
      petIsRabiesVaccinated: [''],
      petIsSkinProblems: [''],
      petIsTicksFleesTreated: [''],
      petTicksFleesTreatedDate: [''],
      petTicksFleesTreatedHowTo: [''],
      petIsRecentlyDeWormed: [''],
      petRecentlyDeWormedDate: [''],
      petIsSpecialDietaryRequirements: [''],
      petSpecialDietaryRequirementsDescription: [''],
      petIsIllLast30Days: [''],
      petIsIllLast30DaysExplanation: [''],
      petIsDisplayingSymptomsCoughingSneezingUpsetStomach: [''],
      petIsMedicalConditionsInjuriesIllnesses: [''],
      petMedicalConditionsInjuriesIllnessesDetails: [''],
      petIsAllergiesFoodSensitivities: [''],
      petAllergiesFoodSensitivitiesDetails: [''],
      disclaimerAgreement: [false, Validators.requiredTrue]
    });
  }

  onSubmit() {
    console.log(`onSubmit`);
    // const formData = getFormData(this.petRegisterForm);
    // logFormData(formData);
    this.createRegisterPetPayload();
    logFormData(this.petRegisterData);
    console.log(`Show success toaster`);
    // this.openSuccessDialog("Successfully registered");
    // this.showSuccessToast("Successfully registered", 'Pet')
    // this.toggleToast();
    this.registerPet();
  }

  changeLanguage(lang: string): void {
    console.log(`lang: ${lang}`);
    this.languageService.setLanguage(lang);
    this.currentLanguage = lang;
  }

  onSelectNationality(event: TypeaheadMatch): void {
    this.selectedNationality = event.item;
    console.log(`onSelectNationality, selectedNationality:${this.selectedNationality}`);
  } // end of onSelectNationality

  createRegisterPetPayload() {
    const formValues = this.petRegisterForm.value;
    const vaccinatedProofFile: File = formValues.petVaccinatedProof;
    const file = this.petRegisterForm.get('petVaccinatedProof')?.value;
    console.log(`createRegisterPetPayload, file name:${file}`);

    const owner = this.dataMappingService.mapRegistrationOwnerDetailFormToJson(this.petRegisterForm)
    console.log(`createRegisterPetPayload, owner: ${JSON.stringify(owner)}`);
    this.petRegisterData.append('owner', JSON.stringify(owner));

    console.log(`createRegisterPetPayload, isPickUpServiceNeededAnswer: ${this.isPickUpServiceNeededAnswer}`);
    if (this.isPickUpServiceNeededAnswer === 'yes') {
      const pick_up = this.dataMappingService.mapRegistrationPickUpFormToJson(this.petRegisterForm)
      this.petRegisterData.append('pick_up', JSON.stringify(pick_up));
    }

    let pets: any[] = [];
    this.petsList.forEach(pet => {
      const pet_json = this.dataMappingService.mapRegistrationPetDetailInterfaceToJson(pet);
      pets.push(pet_json)
    });
    console.log(`createRegisterPetPayload, pets: ${JSON.stringify(pets)}`);
    this.petRegisterData.append('pets', JSON.stringify(pets));
    // this.petRegisterData.append('vaccination_proofs', this.vaccinatedProofFilesList);
    this.vaccinatedProofFilesList.forEach((file, index) => {
      // this.petRegisterData.append('vaccination_proof_' + index, file);
      this.petRegisterData.append(`file_${index}`, file);
      this.petRegisterData.append('vaccination_proofs', file);
    });
  }

  registerPet() {
    this.isRegisteringPet = true;
    console.log(`registerPet, petDetailData:${JSON.stringify(this.petRegisterData)}`);
    this.petService.registerPet(this.petRegisterData).subscribe({
      next: (response) => {
        this.isRegisteringPet = false;
        console.log(`registerPet, response: ${JSON.stringify(response)}`);
        // this.hideModal(true)
        // this.openSuccessDialog("Successfully registered");
        this.showSuccessToast("Pet successfully registered", "Pet Registration");
      },
      error: (error) => {
        this.isRegisteringPet = false;
        const errorDetail = error.error?.detail;
        console.error(`registerPet, error: ${JSON.stringify(error)}, errorDetail: ${errorDetail}`);
        this.showErrorToast(`Pet registration failed: ${errorDetail}`, "Pet Registration");
        // this.hideModal(false)
      }
    });
    this.isRegisteringPet = false;
  } // end of registerPet

  onVaccinationProofSelected(event: any) {
    this.selectedVaccinationProofFile = event.target.files[0];
  }

  openSuccessDialog(message: string): void {
    const initialState: ModalOptions = {
      backdrop: 'static',
      initialState: {
        // class: 'modal-lg',
        title: 'Registration',
        closeBtnName: 'Close',
      },

    };

    this.successModal = this.modalService.show(SuccessDialogComponent, initialState);
    this.successModal.content.message = message;
  }

  showErrorToast(error: string, title: string) {
    this.toastr.clear();
    this.toastr.error(error, title, environment.toastrConfig);
  }

  showSuccessToast(message: string, title: string) {
    this.toastr.clear();
    // this.toastr.success(message, title, environment.toastrConfig);
    this.toastr.success(message, title, {
      timeOut: 3000, // Time to close the notification in milliseconds
      progressBar: true, // Show a progress bar
      positionClass: 'toast-top-right' // Position of the notification
    });

    // this.toastr.success(message, title, {
    //   timeOut: 3000, // Time to close the notification in milliseconds
    //   progressBar: true, // Show a progress bar
    //   positionClass: 'toast-top-right' // Position of the notification
    // });
  }

  toggleToast() {
    this.visible = !this.visible;
  }

  onVisibleChange($event: boolean) {
    this.visible = $event;
    this.percentage = !this.visible ? 0 : this.percentage;
  }

  onTimerChange($event: number) {
    this.percentage = $event * 25;
  }

  setFormFieldsSelectedValue() {
    this.petRegisterForm.get('howDidYouHearAboutGoodDog')?.valueChanges.subscribe(value => {
      console.log(`howDidYouHearAboutGoodPet chang, value: ${value}`);
      this.selectedReferral = value;
    });

    this.petRegisterForm.get('petSex')?.valueChanges.subscribe(value => {
      console.log(`petSex chang, value: ${value}`);
      this.selectedPetSex = value;
      console.log(`petSex chang, value: ${value}, selectedPetSex: ${this.selectedPetSex}`);
    });

    this.petRegisterForm.get('petIsFriendly')?.valueChanges.subscribe(value => {
      console.log(`petIsFriendly chang, value: ${value}`);
      this.selectedPetIsFriendly = value;
      console.log(`petIsFriendly chang, value: ${value}, selectedPetIsFriendly: ${this.selectedPetIsFriendly}`);
    });

    this.petRegisterForm.get('petIsSensitiveBodyOrPhysicalRestriction')?.valueChanges.subscribe(value => {
      console.log(`petIsSensitiveBodyOrPhysicalRestriction chang, value: ${value}`);
      this.selectedPetIsSensitiveBodyOrPhysicalRestriction = value;
      console.log(`petIsSensitiveBodyOrPhysicalRestriction chang, value: ${value}, selectedPetIsSensitiveBodyOrPhysicalRestriction: ${this.selectedPetIsSensitiveBodyOrPhysicalRestriction}`);
    });

    this.petRegisterForm.get('petIsSkinProblems')?.valueChanges.subscribe(value => {
      console.log(`PetIsSkinProblems chang, value: ${value}`);
      this.selectedPetIsSkinProblems = value;
      console.log(`PetIsSkinProblems chang, value: ${value}, selectedPetIsSkinProblems: ${this.selectedPetIsSkinProblems}`);
    });

    this.petRegisterForm.get('petIsTicksFleesTreated')?.valueChanges.subscribe(value => {
      console.log(`petIsTicksFleesTreated chang, value: ${value}`);
      this.selectedPetIsTicksFleesTreated = value;
      console.log(`petIsTicksFleesTreated chang, value: ${value}, selectedPetIsTicksFleesTreated: ${this.selectedPetIsTicksFleesTreated}`);
    });

    this.petRegisterForm.get('petIsRecentlyDeWormed')?.valueChanges.subscribe(value => {
      console.log(`petIsRecentlyDeWormed chang, value: ${value}`);
      this.selectedPetIsRecentlyDeWormed = value;
      console.log(`petIsRecentlyDeWormed chang, value: ${value}, selectedPetIsRecentlyDeWormed: ${this.selectedPetIsRecentlyDeWormed}`);
    });

    this.petRegisterForm.get('petIsSpecialDietaryRequirements')?.valueChanges.subscribe(value => {
      console.log(`petIsSpecialDietaryRequirements chang, value: ${value}`);
      this.selectedPetIsSpecialDietaryRequirements = value;
      console.log(`petIsSpecialDietaryRequirements chang, value: ${value}, selectedPetIsSpecialDietaryRequirements: ${this.selectedPetIsSpecialDietaryRequirements}`);
    });

    this.petRegisterForm.get('petIsIllLast30Days')?.valueChanges.subscribe(value => {
      console.log(`petIsIllLast30Days chang, value: ${value}`);
      this.selectedPetIsIllLast30Days = value;
      console.log(`petIsIllLast30Days chang, value: ${value}, selectedPetIsIllLast30Days: ${this.selectedPetIsIllLast30Days}`);
    });

    this.petRegisterForm.get('petIsMedicalConditionsInjuriesIllnesses')?.valueChanges.subscribe(value => {
      console.log(`petIsMedicalConditionsInjuriesIllnesses chang, value: ${value}`);
      this.selectedPetIsMedicalConditionsInjuriesIllnesses = value;
      console.log(`petIsMedicalConditionsInjuriesIllnesses chang, value: ${value}, selectedPetIsMedicalConditionsInjuriesIllnesses: ${this.selectedPetIsMedicalConditionsInjuriesIllnesses}`);
    });

    this.petRegisterForm.get('petIsAllergiesFoodSensitivities')?.valueChanges.subscribe(value => {
      console.log(`petIsAllergiesFoodSensitivities chang, value: ${value}`);
      this.selectedPetIsAllergiesFoodSensitivities = value;
      console.log(`petIsAllergiesFoodSensitivities chang, value: ${value}, selectedPetIsAllergiesFoodSensitivities: ${this.selectedPetIsAllergiesFoodSensitivities}`);
    });

    this.petRegisterForm.get('branchName')?.valueChanges.subscribe(value => {
      console.log(`branchName chang, value: ${value}`);
      this.selectedBranch = value;
      console.log(`branchName chang, value: ${value}, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
    });

    this.petRegisterForm.get('petType')?.valueChanges.subscribe(value => {
      console.log(`petType chang, value: ${value}`);
      this.selectedPetType = value;
      console.log(`petType chang, value: ${value}, selectedPetType: ${JSON.stringify(this.selectedPetType)}`);
    });

    this.petRegisterForm.get('disclaimerAgreement')?.valueChanges.subscribe(value => {
      console.log(`disclaimerAgreement chang, value: ${value}`);
      // this.selectedBranch = value;
      // console.log(`petRegisterForm chang, value: ${value}, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
    });

    this.petRegisterForm.get('isPickUpServiceNeeded')?.valueChanges.subscribe(value => {
      console.log(`isPickUpServiceNeeded chang, value: ${value}`);
      this.isPickUpServiceNeededAnswer = value;
      console.log(`isPickUpServiceNeeded chang, value: ${value}, isPickUpServiceNeededAnswer: ${JSON.stringify(this.isPickUpServiceNeededAnswer)}`);
      this.petRegisterForm.get('pickUpFirstName')?.setValue(this.petRegisterForm.get('ownerFirstName')?.value);
      this.petRegisterForm.get('pickUpLastName')?.setValue(this.petRegisterForm.get('ownerLastName')?.value);
      this.petRegisterForm.get('pickUpPhone')?.setValue(this.petRegisterForm.get('ownerPhone')?.value);
      this.petRegisterForm.get('pickUpAddress')?.setValue(this.petRegisterForm.get('ownerAddress')?.value);
    });
  }

  getBranches() {
    this.isBranchesLoaded = false;
    this.petService.getBranches().subscribe({
      next: (response) => {
        console.log(`getBranches, response: ${JSON.stringify(response)}`);
        this.branchesList = response;
        this.selectedBranch = this.branchesList[0];
        this.petRegisterForm.get('branchName')?.setValue(this.selectedBranch);
        this.isBranchesLoaded = true;
      },
      error: (error) => {
        this.isBranchesLoaded = true;
        console.error(`getBranches, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getBranches

  onBranchChange() {
    // console.log(`onBranchChange, value: ${JSON.stringify(value)}`);
    console.log(`onBranchChange, selectedBranch: ${JSON.stringify(this.selectedBranch)}`);
    console.log(`onBranchChange, value: ${JSON.stringify(this.petRegisterForm.get('branchName')?.value)}`);
  }

  getPetTypes() {
    this.petService.getPetTypes().subscribe({
      next: (response) => {
        console.log(`getPetTypes, response: ${JSON.stringify(response)}`);
        this.petTypes = response;
        // this.selectedPet = this.petTypes.filter(t => t.name=='Dog')[0];
        this.selectedPetType = this.petTypes[0];
        console.log(`getPetTypes, selectedPetType: ${JSON.stringify(this.selectedPetType)}`);
        this.petRegisterForm.get('petType')?.setValue(this.selectedPetType);
      },
      error: (error) => {
        console.error(`getPetTypes, error: ${JSON.stringify(error)}`);
      }
    });
  } // end of getPetTypes

  showNewPetModal() {
    console.log("PetRegisterComponent ~ showNewPetModal")

    const initialState: ModalOptions = {
      backdrop: 'static',
      initialState: {
        class: 'modal-lg',
        title: 'Add New Pet',
        closeBtnName: 'Close',
        isNew: true,
      },

    };

    // this.petDetailModal = this.modalService.show(PetDetailComponent, initialState);
    this.petDetailModal = this.modalService.show(RegistrationPetDetailDialogComponent, initialState);

    this.petDetailModal.content.onClose.subscribe((result: RegistrationPetDialogResult) => {
      console.log('PetRegisterComponent, showNewPetModal, results: ', result);
      if (result != null) {
        if (result.pet != null) {
          this.petsList.push(result.pet);
        }
        if (result.file != null) {
          this.vaccinatedProofFilesList.push(result.file);
        }
      }
      // this.getPets();
    })
  } // end of showNewPetModal

  showPetDetailModal(index: number) {
    console.log(`PetRegisterComponent ~ showPetDetailModal ~ index: ${JSON.stringify(index)}`);
    this.selectedPet = this.petsList[index];
    console.log(`PetRegisterComponent ~ showPetDetailModal ~ selectedPet: ${JSON.stringify(this.selectedPet)}`);

    const initialState: ModalOptions = {
      backdrop: 'static',
      initialState: {
        class: 'modal-lg',
        title: 'Pet Details',
        closeBtnName: 'Close',
        selectedRegistrationPetDetail: this.selectedPet,
        isNew: false,
      },

    };

    this.petDetailModal = this.modalService.show(RegistrationPetDetailDialogComponent, initialState);
    this.petDetailModal.content.onClose.subscribe((result: RegistrationPetDialogResult) => {
      console.log(`PetRegisterComponent, showNewPetModal, results: ${JSON.stringify(result)}`);
      if (result != null) {
        if (result.pet != null) {
          console.log(`PetRegisterComponent, showNewPetModal, result.pet: ${JSON.stringify(result.pet)}`);
          this.petsList[index] = result.pet;
        }
        if (result.file != null) {
        }
      }
      // this.getPets();
    })
  }
}
